<template>
  <div class="row">
    <div class="col text-center">
      <div class="row">
        <div class="col">
          <img src="https://invoicesainet.blob.core.windows.net/images/J_Logo_Black_256x256.png" alt="App" width="96" />
        </div>
      </div>
      <div class="row mt-2">
        <div class="col">
          <h4>Invoices AI Chrome Extension</h4>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <span>Follow this link to install the Chrome extension:</span>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col">
          <a href="https://chromewebstore.google.com/detail/invoices-ai/jbakhimjkmchebdkinflbicbillbkpad" target="_blank" rel="noopener noreferrer"
            >Invoices AI Chrome Extension</a
          >
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <span>Just click "Get" or "Add to Chrome" and then "Add Extension" to install.</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ExtensionView'
}
</script>
<style lang="scss" scoped></style>
